import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks";
import { deleteGroup, Urs } from "../UrsSlice";
import { DeleteButton } from "../../../app/components/DeleteButton";
import { CancelButton } from "../../../app/components/CancelButton";

export interface DeleteGroupDialogProps {
    id: AppId
    onSuccess: (data: Urs) => void
    onCancel: () => void
}

export const DeleteGroupDialog = (props: DeleteGroupDialogProps) => {
    const { id, onSuccess, onCancel } = props
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [serverError, setServerError] = useState<string | null>(null);

    const handleConfirmDelClick = async () => {
        setSaving(true)
        try {

            const actionResult = await dispatch(deleteGroup(id));

            if (deleteGroup.fulfilled.match(actionResult)) {
                const data = actionResult.payload as Urs;
                onSuccess(data)
            } else {
                let errorMsg = 'error-document-section-has-children';
                if (actionResult.payload && (actionResult.payload as any).kind === 'http') {
                    const problem = (actionResult.payload as any).problem;
                    if (problem) {
                        errorMsg = problem.title;
                    }
                }
                setServerError(errorMsg);
            }

        } catch (e: any) {
            setServerError(e.message ?? 'error');
        } finally {
            setSaving(false);
        }
    }

    return <Dialog open={true}>
        <DialogTitle
            sx={{
                bgcolor: "grey.100",
                borderBottom: 1,
                borderColor: "divider",
                py: 0.5,
                fontWeight: 600,
            }}
        >
            <Localized id="delete">
                <span>Usuń</span>
            </Localized>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
            <Typography variant="body1">
                <Localized id="confirm-delete">
                    <span>Czy na pewno chcesz usunąć?</span>
                </Localized>
            </Typography>
            {serverError && (
                <Alert sx={{ mt: 1 }} onClose={() => setServerError(null)} severity="error">
                    <Localized id={serverError}>
                        <span>Server error</span>
                    </Localized>
                </Alert>
            )}
        </DialogContent>
        <DialogActions>
            <DeleteButton loading={saving} onClick={handleConfirmDelClick} />
            <CancelButton loading={saving} onClick={onCancel} />
        </DialogActions>
    </Dialog>
}
